/**
 * Shared image-upload validation for booking-page forms.
 *
 * Centralizes the size cap and allowed MIME types so the rules stay identical
 * across every upload (logo, banner, profile photo). Update here once.
 */

export const MAX_IMAGE_SIZE_BYTES = 10 * 1024 * 1024; // 10MB
export const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];

/**
 * Throws an Error with a user-facing message when the file is too large or of
 * a disallowed type. Returns nothing when the file is valid.
 *
 * @param {File} file - The file selected for upload.
 */
export const validateImageFile = (file) => {
  if (file.size > MAX_IMAGE_SIZE_BYTES) {
    throw new Error("File size must be less than 10MB");
  }
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    throw new Error("Only JPEG, PNG, and WebP files are allowed");
  }
};
